import React, { useState, useEffect } from 'react'
import './About.scss'


import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import renderOptions from '../utils/textRenderOption';
import { motion, AnimatePresence } from 'framer-motion'

const About = ({ items = [] }) => {
    const [expandedId, setExpandedId] = useState(null);

    // Sort items to put 'à propos' first
    const sortedItems = [...items].sort((a, b) => {
        if (a.titre.toLowerCase().includes('propos')) return -1;
        if (b.titre.toLowerCase().includes('propos')) return 1;
        return 0;
    });

    // Auto-expand first item when page loads
    useEffect(() => {
        if (items.length > 0) {
            const firstSorted = [...items].sort((a, b) => {
                if (a.titre.toLowerCase().includes('propos')) return -1;
                if (b.titre.toLowerCase().includes('propos')) return 1;
                return 0;
            })
            setExpandedId(firstSorted[0].id)
        }
    }, [items])

    // Listen for external requests to close about texts (e.g. menu actions on mobile)
    useEffect(() => {
        const handleClose = () => {
            // only collapse on mobile widths
            if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                setExpandedId(null)
            }
        }
        window.addEventListener('closeAboutTexts', handleClose)
        return () => window.removeEventListener('closeAboutTexts', handleClose)
    }, [])

    const toggleItem = (id) => {
        setExpandedId(prev => (prev === id ? null : id));
    };



    return (
        <div className='aboutPage'>
            <div className='aboutContent'>
                <div className='aboutMenu'>
                    {sortedItems.map((item) => (
                        <div key={item.id} className='aboutMenuItem'>
                            <div
                                className={`aboutMenuTitle ${expandedId === item.id ? 'expanded' : ''}`}
                                onClick={() => toggleItem(item.id)}
                            >
                                {item.titre}
                            </div>
                            <AnimatePresence initial={false}>
                                {expandedId === item.id && (
                                    <motion.div
                                        key={item.id}
                                        className='aboutMenuContent'
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: 'auto', opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                                        style={{ overflow: 'hidden' }}
                                    >
                                        {item.texte && (
                                            <div className='aboutText'>
                                                {documentToReactComponents(item.texte, renderOptions)}
                                            </div>
                                        )}
                                        {item.images && item.images.length > 0 && (
                                            <div className='aboutImages'>
                                                {item.images.map((img, idx) => (
                                                    <img key={idx} src={img} alt={item.titre} />
                                                ))}
                                            </div>
                                        )}
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default About